import { i18n } from "@lingui/core";
import React from 'react';
import Image from 'gatsby-image';
import BlockContent from '@sanity/block-content-to-react';
import { useLingui } from '@lingui/react';
import './single-project.scss';
import Icon from '../../shared/ui-elements/icon/icon';
import Video from '../../shared/ui-elements/video/video';

var SingleProject = function SingleProject(_ref) {
  var project = _ref.project;
  console.log({
    project: project
  });

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var title = project.title,
      publishedAt = project.publishedAt,
      tags = project.tags,
      client = project.client,
      tools = project.tools,
      url = project.url,
      videoUrl = project.videoUrl,
      description = project.description,
      images = project.images;
  return /*#__PURE__*/React.createElement("section", {
    className: "single-project"
  }, /*#__PURE__*/React.createElement("header", {
    className: "single-project__header"
  }, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("div", {
    className: "single-project__meta-wrapper"
  }, /*#__PURE__*/React.createElement("p", null, publishedAt), tags && tags.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "|"), /*#__PURE__*/React.createElement("p", {
    className: "single-project__tag"
  }, tags === null || tags === void 0 ? void 0 : tags.map(function (tag, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i
    }, tag);
  })))), /*#__PURE__*/React.createElement("div", {
    className: "single-project__info-wrapper"
  }, client && /*#__PURE__*/React.createElement("p", null, i18n._(
  /*i18n*/
  i18n._("client")) + ": " + client), tools && tools.length > 0 && /*#__PURE__*/React.createElement("p", null, i18n._(
  /*i18n*/
  i18n._("tools")) + ": " + tools.map(function (tool) {
    return " " + tool;
  })), /*#__PURE__*/React.createElement("a", {
    href: url ? url : undefined,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: 30,
    height: 30,
    id: "icon-link",
    color: "rgb(245, 245, 245)"
  })))), /*#__PURE__*/React.createElement("main", {
    className: "single-project__main"
  }, /*#__PURE__*/React.createElement(Video, {
    src: videoUrl,
    autoPlay: true,
    loop: true
  }), /*#__PURE__*/React.createElement(BlockContent, {
    blocks: description,
    className: "block-content",
    renderContainerOnSingleChild: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "single-project__image-wrapper"
  }, images === null || images === void 0 ? void 0 : images.map(function (img, i) {
    return /*#__PURE__*/React.createElement(Image, {
      key: i,
      fluid: img.asset.fluid,
      alt: "" + title
    });
  }))));
};

export default SingleProject;